// extracted by mini-css-extract-plugin
export var deliveryRow = "_p1-a";
export var fixedHeight = "_p1-4";
export var freightLogo = "_p1-9";
export var fullWidth = "_p1-3";
export var priceColumn = "_p1-5";
export var radioSelected = "_p1-7";
export var radioUnselected = "_p1-6";
export var selectedOption = "_p1-2";
export var selectedOptionContainer = "_p1-1";
export var selection = "_p1-0";
export var tallSkeletonText = "_p1-8";